import axios from '@/libs/api.request';

export const saveDistributionStationPreSaleDeliveryCheck = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/deliveryCheck/saveDistributionStationPreSaleDeliveryCheck',
        data: data,
        method: 'post'
    });
};

export const saveDistributionStationCurSaleDeliveryCheck = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/deliveryCheck/saveDistributionStationCurSaleDeliveryCheck',
        data: data,
        method: 'post'
    });
};

